import { useState } from "react";
import { BConnector, Station } from "../../../../stations/types/stations.types";
import PaygoFormView from "./PaygoFormView/PaygoFormView";
import { usePaygo } from "../../../hooks/usePaygo";
import StationPicker from "../../../../stations/components/StationPicker/StationPicker";
import { Paygo, PaygoRequest } from "../../../types/paygo.types";
import { extractAxoisErrorsMessage } from "../../../../errorHandler/utils/errors.utils";
import inputValidityChecker from "../../../../../utils/inputValidityChecker";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { Client } from "../../../../clients/types/clients.types";
import ClientPicker from "../../../../clients/components/ClientPicker/ClientPicker";
import ConnectorPicker from "../../../../stations/components/ConnectorPicker/ConnectorPicker";

export interface PayGoFormData {
  user?: Client;
  amountKwh?: number;
  station?: Station;
  description?: string;
  connector?: BConnector;

}

export interface PayGoFormErrorsState {
  isErrorUser: boolean;
  isErrorAmountKwh: boolean;
  isErrorStation: boolean;
  messageError?: string;
  allGood: boolean;
  isErrorDescription?: boolean;
  isErrorConnector?: boolean;
}

const PAY_GO_ERROR = {
  isErrorUser: false,
  isErrorAmountKwh: false,
  isErrorStation: false,
  isErrorConnector: false,
  messageError: "",
  allGood: false,
};

export default function PayGoFormPresenter({
  onSuccess,
}: {
  onSuccess?: (paygo: Paygo) => void;
}) {
  const [formData, setFormData] = useState<PayGoFormData>({});
  const [formError, setFormError] = useState<PayGoFormErrorsState>({
    ...PAY_GO_ERROR,
  });

  const { createNewPaygoQuery } = usePaygo({});

  const {  goToSinglePayGo   } = useNavigationApp();
  const setFormDataValue = (key: keyof PayGoFormData, value: any) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const convertPayGoDataFrom = (formData: PayGoFormData): PaygoRequest => {
    return {
      kwh: parseFloat(formData.amountKwh+"" || "0") || 0,
      station_device_id: 0,
      user_int_id: 0,
      station: formData.station?.station_id,
      description: formData.description,
      user_phone_number: formData.user?.client_phone_number,
      user: formData.user?.client_id,
      tag_connector_id: formData.connector?.b_connector_tag_id,
    };
  };

  const checkNewPayGoValid = (paygo: PaygoRequest): PayGoFormErrorsState => {
    const newError = { ...PAY_GO_ERROR };
    newError.allGood = true;

    const messagesList = [];

    if (
     !paygo.user_phone_number || !inputValidityChecker.validateNotEmptyText(paygo.user_phone_number)
  ){ 
      newError.isErrorUser = true;
      messagesList.push("Renseignez un numéro de téléphone");
      newError.allGood = false;
    }
    if (!paygo.station || !inputValidityChecker.validateNotEmptyText(paygo.station)) {
      newError.isErrorStation = true;
      messagesList.push("Veuillez sélectionner une station");
      newError.allGood = false;
    }
    if (!inputValidityChecker.validateNumberFloat(paygo.kwh+"") || paygo.kwh === 0 ) {
      newError.isErrorAmountKwh = true;
      messagesList.push("Veuillez renseigner une quantité de kWh");
      newError.allGood = false;
    }

    if (!paygo.tag_connector_id){
      newError.isErrorConnector = true;
      messagesList.push("Veuillez sélectionner un connecteur");
      newError.allGood = false;
    }

  

    newError.messageError = messagesList.join(", ");

    return newError;
  };
  const handleSubmit = () => {
    const payGo = convertPayGoDataFrom(formData);
    const errorState = checkNewPayGoValid(payGo);

    if (errorState.allGood) {
      createNewPaygoQuery.mutate({
        newData: payGo,
        callback: ({ error, result }) => {
          if (result) {
    
            setFormData({});
            setFormError(PAY_GO_ERROR);
       
            if (onSuccess) {
              onSuccess(result);
            } else {
              goToSinglePayGo(result.paygo_id);
            }
            return
          }
          if (error) {
            const message = extractAxoisErrorsMessage(error);
            setFormError({ ...PAY_GO_ERROR, messageError: message });
            return
          }
        },
      });
    } else {
      setFormError(errorState);
    }
  };

  return (
    <PaygoFormView
      setFormData={setFormDataValue}
      formData={formData}
      messageError={formError?.messageError}
      errorStatus={formError}
      isLoading={createNewPaygoQuery.isLoading}
      stationPickerRender={() => (
        <StationPicker
          currentStation={formData?.station}
          setCurrentStation={(station) =>{ setFormData({ ...formData,station: station, connector: undefined })}}
          isError={formError.isErrorStation}
        />
      )}

      connectorPicker={formData?.station ? () => (
        <ConnectorPicker
          currentConnector={formData?.connector? formData.connector : undefined}
          setCurrentConnector={(connector) => setFormDataValue("connector", connector)}
          isError={formError.isErrorConnector}
          preFilter={{
            station_id: `=${formData?.station?.station_id}`,
          }}
        />
      ) : undefined}
      userPickerRender={() => (
        <ClientPicker
          currentClient={formData?.user || undefined}
          setClient={(user) => setFormDataValue("user", user)}
          isError={formError.isErrorUser}
         textFormat={(user) =>{
          if(!user) return ""
          return (""+(user?.client_lastname ||""  )+" "+user?.client_firstname+ " - "+(user?.client_phone_number || "Aucun numéro"))}}
          createDefaultItem={(value) => ({ client_firstname: "Numéro Iconnu", client_phone_number: value })}
          searchPlaceholder="Rechercher un numéro de téléphone"
          placeHolder="Numéro de téléphone"
        />
      )}
      handleSubmit={handleSubmit}
    />
  );
}
